import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Content from "./content";

import MainLayout from "../../components/leads-layout";
import PrivateLayout from "../../components/private-layout";

const LeadsPage = () => {
  return (
    <React.Fragment>
      <PrivateLayout>
        <Router basename="/leads">
          <MainLayout>
            <Content />
          </MainLayout>
        </Router>
      </PrivateLayout>
    </React.Fragment>
  );
};

export default LeadsPage;
